<template>
    <div class="Report__field__content">
        <div
            v-if="submission"
            class="Report__field__submission"
        >
            <v-textarea
                id="submissionText"
                type="text"
                readonly
                :label="field.name"
                v-model="submission.paragraphText"
                dense
                outlined
            />

            <CopyFieldValue :value="submission.paragraphText" />
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import CopyFieldValue from '@/reports/Fields/Common/CopyFieldValue';

export default {
    components: { CopyFieldValue },
    mixins: [
        ReportFieldBoilerplate
    ]
};
</script>
